import { defineStore } from 'pinia';
import { computed } from 'vue';
import { useAccountStore } from '@stores/account.store';
import { useFanFetcher } from '@api/fan.api';
import type { Fan } from '@interfaces/fan.interface';
import { type UserDetails } from '@modules/UserDetailsForm/UserDetails.interface';

export const useFanStore = defineStore('fan', () => {
  const accountStore = useAccountStore();

  const fanFetcher = useFanFetcher();
  const fanId = computed(() => fanFetcher.get.data.value?.id);
  const fanEmail = computed(() => fanFetcher.get.data.value?.email);

  // TODO: review interfaces, make it one
  const setFanGetFetcherData = (data: Fan | UserDetails) => {
    fanFetcher.get.data.value = data;
  };

  const fanPatch = async (userData: UserDetails, token?: string) => {
    await fanFetcher.patch.execute(userData, token || accountStore.authToken);
    if (fanFetcher.patch.error.value) return;
    setFanGetFetcherData(userData);
  };

  const fanGet = async () => {
    await fanFetcher.get.execute({}, accountStore.authToken);
    if (!fanFetcher.get.data.value?.token) {
      accountStore.logoutFan(true);
    }
  };

  const hasMissingFields = computed(() => {
    if (fanFetcher.get.isFetching.value) return false;
    if (!fanFetcher.get.data.value) return true;

    return false;
    // Temporary disabled to avoid blocking users from accessing the app
    // return (
    //   !fanFetcher.get.data.value.firstName ||
    //   !fanFetcher.get.data.value.lastName ||
    //   !fanFetcher.get.data.value.email ||
    //   !fanFetcher.get.data.value.location ||
    //   !fanFetcher.get.data.value.phoneNumber ||
    //   !fanFetcher.get.data.value.birthDate
    // );
  });

  const clear = () => {
    fanFetcher.get.data.value = null;
    fanFetcher.get.error.value = null;
    fanFetcher.patch.data.value = null;
    fanFetcher.patch.error.value = null;
  };

  return {
    fanId,
    fanEmail,
    hasMissingFields,

    fanData: fanFetcher.get.data,
    fanError: fanFetcher.get.error,
    isFanFetching: fanFetcher.get.isFetching,
    fanGet,

    fanPatchData: fanFetcher.patch.data,
    fanPatchError: fanFetcher.patch.error,
    isFanPatchFetching: fanFetcher.patch.isFetching,
    fanPatch,

    setFanGetFetcherData,
    clear,
  };
});
